import { render, staticRenderFns } from "./AEMajor.vue?vue&type=template&id=4375a6d8&scoped=true&"
import script from "./AEMajor.vue?vue&type=script&lang=js&"
export * from "./AEMajor.vue?vue&type=script&lang=js&"
import style0 from "./AEMajor.vue?vue&type=style&index=0&id=4375a6d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4375a6d8",
  null
  
)

export default component.exports